import type { MoodState, SocialContext } from "./types";

export const MOODS: MoodState[] = [
  { id: 0, from: 0, to: 0.12, label: "Cansado", emoji: "😴", hint: "Planes cortos, silla y poco desplazamiento" },
  { id: 1, from: 0.12, to: 0.24, label: "Relajado", emoji: "😌", hint: "Café, lectura, parque suave" },
  { id: 2, from: 0.24, to: 0.36, label: "Meditativo", emoji: "🧘", hint: "Museo, jardín, silencio" },
  { id: 3, from: 0.36, to: 0.48, label: "Productivo", emoji: "💪", hint: "Taller, biblioteca, recado útil" },
  { id: 4, from: 0.48, to: 0.6, label: "Social", emoji: "🤝", hint: "Terraza, plaza, conversación" },
  { id: 5, from: 0.6, to: 0.72, label: "Creativo", emoji: "🎨", hint: "Galería, mercado, foto callejera" },
  { id: 6, from: 0.72, to: 0.84, label: "Energético", emoji: "⚡", hint: "Bici, pista, ruta urbana" },
  { id: 7, from: 0.84, to: 0.93, label: "Aventurero", emoji: "🚀", hint: "Mirador, barrio nuevo, reto" },
  { id: 8, from: 0.93, to: 1.01, label: "Adrenalina", emoji: "🔥", hint: "Escape, noche, deporte intenso" },
];

export function moodFromSlider(value: number): MoodState {
  if (!Number.isFinite(value)) return MOODS[4];
  if (value <= 0) return MOODS[0];
  if (value >= 1) return MOODS[MOODS.length - 1];
  return MOODS.find((mood) => value >= mood.from && value < mood.to) ?? MOODS[4];
}

export const SOCIAL_OPTIONS: { key: SocialContext; label: string; icon: string }[] = [
  { key: "solo", label: "Solo", icon: "🧘" },
  { key: "pareja", label: "Pareja", icon: "❤️" },
  { key: "amigos", label: "Amigos", icon: "👥" },
  { key: "familia", label: "Familia", icon: "👨‍👩‍👧‍👦" },
  { key: "familia_extendida", label: "Clan", icon: "🏡" },
  { key: "colegas", label: "Colegas", icon: "💼" },
  { key: "ninos", label: "Niños", icon: "👶" },
  { key: "mascotas", label: "Mascotas", icon: "🐕" },
  { key: "networking", label: "Networking", icon: "🤝" },
];